/* eslint-disable array-callback-return */
import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { IUserAgent } from "../ITemplateDetail";

type DeviceInfoProps = {
  userAgent: IUserAgent;
};
export const DeviceInfo = ({ userAgent }: DeviceInfoProps) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          m: "10px",
        }}
        minHeight={60}
      >
        <Box sx={{ width: "24px", mr: "8px" }} />
        <Box width={"30%"}>
          <Typography fontWeight={900}>Information</Typography>
        </Box>
      </Box>
      <Divider sx={{ mt: "-25px" }} />
      {userAgent.appName && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            m: "10px",
            mt: "6.5px",
            mb: "6.5px",
          }}
          minHeight={20}
        >
          <Box sx={{ width: "24px", mr: "8px" }} />
          <Box width={"30%"}>
            <Typography fontWeight={500}>Application</Typography>
          </Box>
          <Box>
            <Typography minWidth={"20%"} maxWidth={650}>
              {userAgent.appName === "kinemaster" ? "KineMaster" : "Spring"}
            </Typography>
          </Box>
        </Box>
      )}

      {userAgent.userAgent && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            m: "10px",
            mt: "6.5px",
            mb: "6.5px",
          }}
          minHeight={20}
        >
          <Box sx={{ width: "24px", mr: "8px" }} />
          <Box width={"30%"}>
            <Typography fontWeight={500}>User Agent</Typography>
          </Box>
          <Box>
            <Typography minWidth={"20%"} maxWidth={650}>
              {userAgent.userAgent}
            </Typography>
          </Box>
        </Box>
      )}
      {userAgent.appVersion && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            m: "10px",
            mt: "6.5px",
            mb: "6.5px",
          }}
          minHeight={20}
        >
          <Box sx={{ width: "24px", mr: "8px" }} />
          <Box width={"30%"}>
            <Typography fontWeight={500}>App Version</Typography>
          </Box>
          <Box>
            <Typography minWidth={"20%"} maxWidth={650}>
              {userAgent.appVersion}
            </Typography>
          </Box>
        </Box>
      )}
      {userAgent.model && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            m: "10px",
            mt: "6.5px",
            mb: "6.5px",
          }}
          minHeight={20}
        >
          <Box sx={{ width: "24px", mr: "8px" }} />
          <Box width={"30%"}>
            <Typography fontWeight={500}>Model</Typography>
          </Box>
          <Box>
            <Typography minWidth={"20%"} maxWidth={650}>
              {userAgent.model}
            </Typography>
          </Box>
        </Box>
      )}
      {userAgent.os && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            m: "10px",
            mt: "6.5px",
            mb: "6.5px",
          }}
          minHeight={20}
        >
          <Box sx={{ width: "24px", mr: "8px" }} />
          <Box width={"30%"}>
            <Typography fontWeight={500}>OS</Typography>
          </Box>
          <Box>
            <Typography minWidth={"20%"} maxWidth={650}>
              {userAgent.os}
            </Typography>
          </Box>
        </Box>
      )}
      {userAgent.osVersion && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            m: "10px",
            mt: "6.5px",
            mb: "6.5px",
          }}
          minHeight={20}
        >
          <Box sx={{ width: "24px", mr: "8px" }} />
          <Box width={"30%"}>
            <Typography fontWeight={500}>OS Version</Typography>
          </Box>
          <Box>
            <Typography minWidth={"20%"} maxWidth={650}>
              {userAgent.osVersion}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};
